import root from 'window-or-global';
import type { BrowserOptions } from '@sentry/react';

export const config: BrowserOptions = {
  attachStacktrace: true,
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  ],
  dsn: 'https://c2532dd7a60242628def80ac35a40dae@sentry.io/269866',
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    `TypeError: Cannot read property '_avast_submit' of undefined`,
    // Facebook borked
    'fb_xd_fragment',
    // animation frame errors - supported by all Waitrose supported browsers
    'window.cancelAnimationFrame',
    'window.requestAnimationFrame',
    /google_tag_manager\[['"]GTM-[0-z]{6}['"]\]\.macro\(/i,
    // Ignore http errors
    /Error: Unsuccessful HTTP Response.*/i,
    // Ignores expected 401 errors
    /Error: Unauthorized.*/i,
    // Ignores expected 401 errors
    /Error: {"errors":\[{"message":"Unauthorised"*/i,
    /Error: Not Found.*/i,
    /Error: Internal Server Error.*/i,
    /Error: HTTP\/2\.0.*/i,
    /Error: Conflict.*/i,
    /Error: Response timeout of 30000ms exceeded.*/i,
    // Ignore vague error that's not affecting customers (most likely 3rd parties or extensions) - https://github.com/getsentry/sentry-javascript/issues/2546
    'Non-Error promise rejection captured with keys: currentTarget, detail, isTrusted, target',
  ],
  maxBreadcrumbs: 150,
  release: root.SENTRY_RELEASE,
};
